module.exports = __webpack_public_path__ + "img/Monte_Kope_98.453017c2.jpg";